/* eslint-disable */
import { addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";

const widgets = require.context("../../blueprints/iewc/src/WidgetExtensions/Widgets", true, /.tsx$/);
addWidgetsFromContext(widgets);
